/* HW40 PRODUCT — gallery peek slider + cart actions + accordions */
(function(){
  // ─── GALLERY ───
  document.querySelectorAll('[data-hw40-gallery]').forEach(function(g){
    var track = g.querySelector('[data-hw40-gallery-track]');
    var slides = g.querySelectorAll('[data-hw40-slide]');
    var thumbs = g.querySelectorAll('[data-hw40-thumb]');
    var prev = g.querySelector('[data-hw40-prev]');
    var next = g.querySelector('[data-hw40-next]');
    var idx = 0;
    function go(i){
      idx = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-idx * 100) + '%)';
      thumbs.forEach(function(t,j){ t.classList.toggle('is-active', j === idx); });
    }
    thumbs.forEach(function(t,i){ t.addEventListener('click', function(){ go(i); }); });
    if(prev) prev.addEventListener('click', function(){ go(idx - 1); });
    if(next) next.addEventListener('click', function(){ go(idx + 1); });
    // touch swipe
    var sx = 0;
    track.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; });
    track.addEventListener('touchend', function(e){
      var dx = e.changedTouches[0].clientX - sx;
      if(Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
    });
  });

  // ─── PRICING TIER RADIO ───
  document.querySelectorAll('[data-hw40-tier-group]').forEach(function(group){
    var tiers = group.querySelectorAll('[data-hw40-tier]');
    var totalEl = document.querySelector('[data-hw40-total]');
    var atcBtn = document.querySelector('[data-hw40-atc]');
    function select(t){
      tiers.forEach(function(x){ x.classList.remove('is-active'); });
      t.classList.add('is-active');
      var p = t.getAttribute('data-price');
      var v = t.getAttribute('data-variant');
      if(totalEl && p) totalEl.textContent = p;
      if(atcBtn && v) atcBtn.setAttribute('data-variant', v);
    }
    tiers.forEach(function(t){ t.addEventListener('click', function(){ select(t); }); });
  });

  // ─── ADD TO CART (single + upsell + ritual bundle) ───
  function toast(msg){
    var t = document.createElement('div');
    t.className = 'hw40-toast';
    t.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 7"/></svg><span>' + msg + '</span>';
    document.body.appendChild(t);
    setTimeout(function(){ t.classList.add('is-visible'); }, 10);
    setTimeout(function(){ t.classList.remove('is-visible'); }, 2600);
    setTimeout(function(){ t.remove(); }, 3000);
  }
  function bumpCart(){
    var c = document.querySelector('[data-cart-count]') || document.querySelector('.cart-count-bubble');
    if(!c) return;
    var n = parseInt(c.textContent || '0', 10) || 0;
    c.textContent = n + 1;
    c.classList.add('is-bumped');
    setTimeout(function(){ c.classList.remove('is-bumped'); }, 600);
  }
  function addToCart(items, msg){
    if(!items || !items.length) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function(r){ return r.json(); }).then(function(data){
      toast(msg || 'Added to cart ✓');
      items.forEach(bumpCart);
    }).catch(function(){ toast('Could not add — try again'); });
  }
  // single ATC
  document.querySelectorAll('[data-hw40-atc]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var v = btn.getAttribute('data-variant'); if(!v) return;
      var items = [{ id: parseInt(v, 10), quantity: 1 }];
      // include upsell if checked
      var up = document.querySelector('[data-hw40-upsell]:checked');
      if(up && up.value){ items.push({ id: parseInt(up.value, 10), quantity: 1 }); }
      addToCart(items, 'Added to cart ✓');
    });
  });
  // ritual product checkboxes — add single
  document.querySelectorAll('[data-hw40-ritual-add]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var v = btn.getAttribute('data-variant'); if(!v) return;
      addToCart([{ id: parseInt(v, 10), quantity: 1 }], 'Product added ✓');
    });
  });
  // ritual bundle — add all
  document.querySelectorAll('[data-hw40-ritual-bundle]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var raw = btn.getAttribute('data-variants') || '';
      var ids = raw.split(',').map(function(x){ return parseInt(x.trim(), 10); }).filter(Boolean);
      var items = ids.map(function(id){ return { id: id, quantity: 1 }; });
      if(!items.length) return;
      addToCart(items, 'Ritual added ✓');
    });
  });

  // ─── ACCORDIONS ───
  document.querySelectorAll('[data-hw40-acc]').forEach(function(acc){
    var btn = acc.querySelector('[data-hw40-acc-btn]');
    var body = acc.querySelector('[data-hw40-acc-body]');
    if(!btn || !body) return;
    btn.addEventListener('click', function(){
      var open = acc.classList.toggle('is-open');
      body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
    });
  });
})();
